module.exports = __webpack_public_path__ + "static/img/guess_words.bcf2f3f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/quiz_center/guess_words.png
// module id = XpA4
// module chunks = 1